// config.js

// @ts-nocheck

// ensure env object exists
window.env = window.env || {};

// read env variables from window.env
const {
  REACT_APP_ENV,
  REACT_APP_BASE_URL_PORTAL,
  REACT_APP_BASE_URL_USER_SERVICE,
} = window.env;

// set env variables on config object
const config = {
  env: REACT_APP_ENV || "local",
  version: process.env.REACT_APP_VERSION || "local",
  url: {
    PORTAL: REACT_APP_BASE_URL_PORTAL || "http://localhost:80",
    USER_SERVICE: REACT_APP_BASE_URL_USER_SERVICE || "http://localhost:9090",
  },
  session: {
    INTERVAL: 1000 * 60 * 2, // 2 min
  },
};

export default config;
